// Angular imports
import { Pipe, PipeTransform } from '@angular/core';

// 3rd party imports
import { formatNumber } from 'devextreme/localization';

// Constant imports
import { StringFormatConstants } from '../_constants/string-format-constants';

// Service imports
import { PrecisionService } from '../_services/shared-services/precision.service';

@Pipe({
    name: 'ccCurrency'
})
export class CCCurrencyPipe implements PipeTransform {
    private readonly _currencyFormat = StringFormatConstants.currencyFormat;

    constructor(private readonly precisionService: PrecisionService) {
        this._currencyFormat = this.precisionService.updatePrecisionPoint(this._currencyFormat);
    }

    getCurrencyFormat(): string {
        return this._currencyFormat;
    }

    transform(value: number): string {
        return formatNumber(value, this._currencyFormat);
    }
}
